export default function formDataLayers() {
  var formData = {};

  // Collect form data when the form is rendered
  jQuery(document).on("gform_post_render", function (event, formId) {
    if (formId === 1 || formId === 2 || formId === 3 || formId === 4) {
      // console.log("Form with ID rendered: " + formId);

      // Get the phone value
      var phoneValue = jQuery("#input_" + formId + "_4").val();

      // Collect and store the form data
      formData = {
        email: jQuery("#input_" + formId + "_3").val(),
        phone: phoneValue ? "+372" + phoneValue : "", // Add +372 prefix if phone is filled
        address: {
          first_name: jQuery("#input_" + formId + "_1").val(),
          last_name: jQuery("#input_" + formId + "_2").val(),
        },
      };

      sessionStorage.setItem("formData", JSON.stringify(formData));

      // console.log("Collected form data: ", formData);
    }
  });

  // Push data to the data layer after form submission
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    if (formId === 1 || formId === 2 || formId === 3 || formId === 4) {
      // console.log("Form with ID confirmation loaded: " + formId);

      // Retrieve the stored form data
      var storedFormData = formData;

      if (storedFormData) {
        if (formId === 1) {
          var formName = "Peamine kontaktivorm";
        } else if (formId === 2) {
          var formName = "Objekti kontaktivorm";
        } else if (formId === 3) {
          var formName = "Kliendipäeva kontaktivorm";
        } else if (formId === 4) {
          var formName = "Allveelaeva 2 huvi kontaktivorm";
        }

        // console.log("Pushing customer data to data layer: ", storedFormData);

        // Push the data to the data layer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "generate_lead",
          customer: storedFormData,
          form: {
            name: formName,
          },
        });

        // Optional: Clear the stored data if no longer needed
        sessionStorage.removeItem("formData");
      } else {
        console.error("No form data found to push to data layer.");
      }
    }
  });
}
